module.exports = __webpack_public_path__ + "static/git-img-4ce5821abec3095808d7e05dd67ddf9e.jpeg";